import React, { useState, useEffect } from 'react';

import { Modal, Input } from '@bigcommerce/big-design';

const EditAddressModal = ({ payload, showEditAddressModal, setShowEditAddressModal, address, updateLocation, setSubmitted }) => {
  const [id, setId] = useState(address?.id)
  const [label, setLabel] = useState(address?.label);
  const [firstName, setFirstName] = useState(address?.first_name);
  const [lastName, setLastName] = useState(address?.last_name);
  const [company, setCompany] = useState(address?.company);
  const [street1, setStreet1] = useState(address?.street_1);
  const [street2, setStreet2] = useState(address?.street_2);
  const [city, setCity] = useState(address?.city);
  const [zip, setZip] = useState(address?.zip);
  const [country, setCountry] = useState(address?.country);
  const [state, setState] = useState(address?.state);

  const addressJson = () => {
    return {
      id: id,
      label: label,
      first_name: firstName,
      last_name: lastName,
      company: company,
      street_1: street1,
      street_2: street2,
      city: city,
      zip: zip,
      country: country,
      state: state
    }
  }

  const update = () => {
    updateLocation(payload, addressJson());
    setSubmitted(true);
    setShowEditAddressModal(false);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => setShowEditAddressModal(false),
        },
        { text: 'Update Address', onClick: () => update() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Edit Address"
      isOpen={showEditAddressModal}
      onClose={() => setShowEditAddressModal(false)}
    >
      <Input
        required
        onChange={(e) => setLabel(e.target.value)}
        placeholder="Label"
        label="Label"
        value={label}
        type="text"
      />

      <Input
        onChange={(e) => setFirstName(e.target.value)}
        placeholder="First Name"
        label="First Name"
        value={firstName}
        type="text"
      />

      <Input
        onChange={(e) => setLastName(e.target.value)}
        placeholder="Last Name"
        label="Last Name"
        value={lastName}
        type="text"
      />

      <Input
        onChange={(e) => setCompany(e.target.value)}
        placeholder="Company"
        label="Company"
        value={company}
        type="text"
      />

      <Input
        required
        onChange={(e) => setStreet1(e.target.value)}
        placeholder="Street 1"
        label="Street 1"
        value={street1}
        type="text"
      />

      <Input
        onChange={(e) => setStreet2(e.target.value)}
        placeholder="Street 2"
        label="Street 2"
        value={street2}
        type="text"
      />

      <Input
        required
        onChange={(e) => setCity(e.target.value)}
        placeholder="City"
        label="City"
        value={city}
        type="text"
      />

      <Input
        required
        onChange={(e) => setState(e.target.value)}
        placeholder="State"
        label="State"
        value={state}
        type="text"
      />

      <Input
        required
        onChange={(e) => setCountry(e.target.value)}
        placeholder="Country"
        label="Country"
        value={country}
        type="text"
      />

      <Input
        required
        onChange={(e) => setZip(e.target.value)}
        placeholder="Zip"
        label="Zip"
        value={zip}
        type="text"
      />
    </Modal>
  )
}

export default EditAddressModal;